import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor($rootScope, $state, Alert, ApplicationsResource) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
        this.resetSessionRecordingSettings();
    }

    sessionRecordingSettingsChanged($value, $invalid) {
        this.sessionRecordingSettings = $value;
        this.invalidSessionRecordingSettings = $invalid;
    }

    sessionRecordingSettingsIsNotModified() {
        return angular.equals(this.$sessionRecordingSettings, this.sessionRecordingSettings);
    }

    resetSessionRecordingSettings() {
        this.$sessionRecordingSettings = angular.copy(this.application.sessionRecordingSettings);
        this.sessionRecordingSettings = angular.copy(this.application.sessionRecordingSettings);
    }

    save(dto) {
        this.isSaving = true;
        return this.ApplicationsResource
            .updateApplicationConfiguration(this.companyId, this.application.id, dto)
            .then(() => {
                this.Alert('success', 'company.manage-application.configuration.saved');
                Object.assign(this.application, dto);
                this.$onInit();
                this.$state.reload('company.manage-application');
            })
            .finally(() => this.isSaving = false)
    }

    saveSessionRecordingSettings() {
        this.isSavingSessionRecordingSettings = true;
        console.log('sessionRecordingSettings is ' + this.sessionRecordingSettings);
        console.log('$sessionRecordingSettings is ' + this.$sessionRecordingSettings);

        this.save({
            ...this.application,
            ...{sessionRecordingSettings: this.sessionRecordingSettings}
        }).finally(() => this.isSavingSessionRecordingSettings = false)
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/session-recording/session-recording.controller.js